define('views/modules/setting/business/blocks/brand/brand-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/setting/business/blocks/brand/brand-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VBrandEditContent
) {

    var VBrandEditPanel = VBasePanel.extend({
        header: {
            title: "Brand",
            subtitle: "Edit your brand",
        },
        tabs: [{ id: 'brand', title: 'Brand', callback: this.onTabBrand, active: true }],
        content: {
            brand: VBrandEditContent
        },
        defaultView: 'brand',
        initialize: function(opt) {
            var brand = this.getView('brand', { model: this.model });
            this.listenTo(brand, 'form:success', this.onSave);
        },
        onSave: function() {
            this.close();
            this.trigger('brand:save');
        }
    });

    return VBrandEditPanel;
});

